module.exports = __webpack_public_path__ + "img/emptyFolders.464d2bca.svg";